import request, { Response } from '@/helpers/requests'
import { SocialMediaSource } from '@/types/social-media'


export interface SocialMediaUrl {
    socialMediaId: number;
    source: SocialMediaSource;
}


export interface LoadSocialMediaResponse extends Response {
    data: {
        pulsemAccountId: number;
        socialMediaUrls: SocialMediaUrl[];
    };
}


export async function loadSocialMedias(pulsemAccountId: number): Promise<LoadSocialMediaResponse> {
    return await request.post('/support/social-media-capture-load/load', {
        pulsemAccountId
    }) as LoadSocialMediaResponse
}
